export default (rootElement, selectorPrefix) => {
  const dropdown = rootElement.querySelector(`${selectorPrefix}`);
  if (!dropdown) {
    return;
  }
  const dropdownTarget = dropdown.querySelector(`${selectorPrefix}__target`);
  const dropdownBody = dropdown.querySelector(`${selectorPrefix}__body`);
  dropdownTarget.addEventListener('click', () => {
    if (dropdownTarget.closest('._skelton')) {
      return;
    }

    dropdown.classList.toggle('is-drop');
    if (dropdown.classList.contains('is-drop')) {
      dropdownBody.style.height = `${dropdownBody.firstElementChild.clientHeight}px`
    } else {
      dropdownBody.style.height = '';
    }
  })
}
